$(document).ready(function($) {

    //console.log("document ready");

	/*$.cookieBar({
		fixed:true,
		bottom:true
	});*/

	$('.menu-button-mobile span').click(function(){
		$('.navbar').toggleClass( "menu-open" );
		$( 'body' ).addClass("fixedposition");
	});

	$('.closebtn').click(function(){
		$('.navbar').toggleClass( "menu-open" );
		$( 'body' ).removeClass("fixedposition");
	});

	//sticky header for desktop.
	var headerheight = $('header').height();
	if($(window).width() > 767) {
		$('.navbar-row').css('min-height',$('.navbar').height());
		sticky_product();
	}

	//sticky header in mobile mode.
	var header_icons_mobile = $('.header-icons-mobile');
	var stickyHeader = $('header').height()-header_icons_mobile.height();


	$( window ).resize(function() {
  		stickyHeader = $('header').height()-header_icons_mobile.height();
  		headerheight = $('header').height();
  		if($(window).width() > 767 ) {
  			$('#searchForm').removeClass('in');
		    $('#searchForm').removeClass('stickySearchbar');
		    $('.searchWrapper').removeClass('search-wrapper-minheight');
		    $('.navbar-row').css('min-height',$('.navbar').height());
		    sticky_product();
  		} else {
  			$('.navbar-row').css('min-height',0);
  			$(".product-image-div").trigger("sticky_kit:detach");
  		}
	});
    
	var navbar = $('.navbar');

	$(window).scroll(function(event) {  
		//sticky header in mobile mode.
		if($(window).width() < 767 ) {
		    sticky_menu_mobile(event);
		}
	    
	    //sticky header for desktop.
	    if($(window).width() > 767) {
		    if ($(window).scrollTop() > headerheight) {
		        navbar.addClass('affix');
		    }
		    else {
		        navbar.removeClass('affix');
		    } 

	    } 
	});
	

    //handling the hover event in touch screen devices(tablet)
    $('ul li.dropdown').on("touchstart", function (e) {
		'use strict'; 
		if($(window).width() > 767 ) {
			var link = $(this); //preselect the link
			
			if (link.hasClass('hover')) {
				$("ul li.hover").removeClass('hover');
			} 
			else {
			   link.addClass('hover');
			   //alert("new hover");
			   $('.nav > li').not(this).removeClass('hover');
			   //return false; //extra, and to make sure the function has consistent return points
			 }
			return false;
		}
	});

	/*for closing the dropdown menu in tabletmode on click of a body*/
	$(document).on("touchstart", function (e) {
		if($(window).width() > 767 ) {
	  		$("ul li.hover").removeClass('hover');
	  	}
	});

	// Prevents the hover from closing
	$('ul li.dropdown').on('touchstart', '.collapse a', function(event) {
		event.stopPropagation();
	});

	$('nav-mobile-collapse-link').on('click',function(e){
		e.stopPropagation();
	});

	//search functionality
	$('.searchButton-mobile').on('click', function(){
        console.log("search button trigger");
		//To remove the jumping in stickysearchbar added the minheight to searchwrapper
		$('.searchWrapper').toggleClass('search-wrapper-minheight');
		
		if($('.header-icons-mobile').hasClass('sticky')){
			$('#searchForm').toggleClass('stickySearchbar');
		}
	});


	//sticky kit plugin for sticky product on product page.
	function sticky_product() {

		var product_offset_top = $('.navbar').outerHeight() + 50;

		$(".product-image-div").stick_in_parent({offset_top:product_offset_top});

		$('.product-image-div')
		.on('sticky_kit:bottom', function(e) {
		    $(this).parent().css('position', 'static');
		})
	}

	//sticky navbar mobile
	function sticky_menu_mobile(event) {
		if ($(window).scrollTop() > stickyHeader) {
	        $('.header-icons-mobile').addClass('sticky');

	        if($('#searchForm').hasClass('in')){
	        	$('#searchForm').addClass('stickySearchbar');
	        }

	        if($(".bc-sf-search-suggestion-wrapper ul").css('display') == 'block'){
       			$('.bc-sf-search-suggestion-wrapper').addClass('fixedPositionSuggestionBox');
			}
			
	        
	    }
	    else {
	        $('.header-icons-mobile').removeClass('sticky');
	        if($('#searchForm').hasClass('in')){
	        	$('#searchForm').removeClass('stickySearchbar');
	        }
	        if($(".bc-sf-search-suggestion-wrapper ul").css('display') == 'block'){
		        $('.bc-sf-search-suggestion-wrapper').removeClass('fixedPositionSuggestionBox');
		        $('.bc-sf-search-suggestion-wrapper').css('top','276.504px');
		    }
	    }  
	}

});


